import { makeStyles } from "@material-ui/core/styles";
import { grey300, secondary, error } from "../../../../theme/customColors";

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
    maxWidth: theme.spacing(30),
  },
  label: {
    fontSize: "12px",
    lineHeight: "14px",
  },
  inputStyle: {
    minWidth: theme.spacing(30),
    paddingRight: theme.spacing(6),
  },
  linkContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
  },
  linkStyle: {
    color: secondary,
    cursor: "pointer",
    position: "absolute",
    right: 0,
  },
  disabled: {
    color: grey300,
  },
  errorStyle: {
    marginTop: theme.spacing(0.5),
    color: error,
  },
}));

export default useStyles;
